import { render, staticRenderFns } from "./show-liquidez-readonly.vue?vue&type=template&id=e4edbc44&"
import script from "./show-liquidez-readonly.vue?vue&type=script&lang=js&"
export * from "./show-liquidez-readonly.vue?vue&type=script&lang=js&"
import style0 from "./show-liquidez-readonly.vue?vue&type=style&index=0&lang=sass&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSheet,VSimpleTable})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4edbc44')) {
      api.createRecord('e4edbc44', component.options)
    } else {
      api.reload('e4edbc44', component.options)
    }
    module.hot.accept("./show-liquidez-readonly.vue?vue&type=template&id=e4edbc44&", function () {
      api.rerender('e4edbc44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/show-liquidez-readonly.vue"
export default component.exports